/////////////////////////////////////////////
//Dependencies
import React from 'react'
import { NavLink } from 'react-router-dom';

/////////////////////////////////////////////
//CSS
import "./Banner.css";

/////////////////////////////////////////////
//Component

/**
 * Banner component
 * 
 * @param {Object} props            - The component props.
 * @param {string} props.imagelogo  - The logo image name.
 * @param {string} props.imagebg    - The background image name.
 * @param {string} props.title      - The title text.
 * @param {string} props.subtitle   - The subtitle text.
 * @param {string} props.link       - The link URL.
 * @param {string} props.name       - The button text.
 * @returns {JSX.Element}           - The rendered Banner component.
 */
export default function Banner({ imagelogo, imagebg, title, subtitle, link, name }) {
    return (
        <>
            <div className="banner-container" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(img/assets/${imagebg})`}}>
                <div className="banner-image">
                    <img src={`img/logo/${imagelogo}.png`} alt={`banner${imagelogo}`} />              
                </div>
                <div className="banner-content">
                    <div className="banner-text">
                        <div className="banner-title">{title}</div>
                        {/* <div className="banner-subtitle">{subtitle}</div> */}
                    </div>
                    <div className="banner-button">
                        <NavLink className='more' to={`/${link}`}>
                            <button className='banner-button-discover'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path></svg>
                                <div className='banner-button-discover-text'>{name}</div>
                            </button>
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    )
};
